import { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Building2, Users, FileImage, CreditCard, Hourglass, Package } from "lucide-react";

export default function AdminDashboard() {
  const [s, setS] = useState({});

  useEffect(() => {
    api.get("/admin/dashboard").then((r) => setS(r.data));
  }, []);

  const STATS = [
    { label: "Workspaces", value: s.workspaces, icon: Building2, testid: "admin-stat-ws" },
    { label: "Users", value: s.users, icon: Users, testid: "admin-stat-users" },
    { label: "Review items", value: s.review_items, icon: FileImage, testid: "admin-stat-items" },
    { label: "Active subscriptions", value: s.active_subscriptions, icon: CreditCard, testid: "admin-stat-subs" },
    { label: "Pending subscriptions", value: s.pending_subscriptions, icon: Hourglass, testid: "admin-stat-pending" },
    { label: "Plans", value: s.plans, icon: Package, testid: "admin-stat-plans" },
  ];

  return (
    <>
      <PageHeader
        eyebrow="Super Admin"
        title="Platform overview"
        description="Real-time stats across all workspaces."
        testid="admin-dashboard-header"
      />
      <div className="px-4 sm:px-6 md:px-10 py-8 grid md:grid-cols-3 gap-3">
        {STATS.map((st) => (
          <div key={st.label} className="border border-border p-6" data-testid={st.testid}>
            <div className="flex items-center justify-between mb-3">
              <span className="label-eyebrow">{st.label}</span>
              <st.icon className="w-4 h-4 opacity-60" />
            </div>
            <div className="text-4xl font-bold" style={{ fontFamily: "var(--font-heading)" }}>{st.value ?? "—"}</div>
          </div>
        ))}
      </div>
    </>
  );
}
